'use client';

import Avatar from "./components/Avatar";
import Combine from "./components/Combine";
import Mono from "./components/Mono";
import Text from "./components/Text";
import { COLOR_GPT_3, COLOR_GPT_4, COLOR_O_1, COLOR_PRIMARY, TITLE } from "./style";
var Icons = Mono;
Icons.Text = Text;
Icons.Combine = Combine;
Icons.Avatar = Avatar;
Icons.colorPrimary = COLOR_PRIMARY;
Icons.colorGpt3 = COLOR_GPT_3;
Icons.colorGpt4 = COLOR_GPT_4;
Icons.colorO1 = COLOR_O_1;
Icons.title = TITLE;
export default Icons;